<template>
  <div class="container" :style="{'flex-direction':isVertical?'column':'row','height':height}">
    <slot></slot>
  </div>
</template>

<script>
    export default {
        name: "index",
        props:{
            isVertical:{
                type:Boolean,
                default:false
            },
            height:{
                type:String,
                default:'100%'
            },
        }
    }
</script>

<style scoped>
  .container{
    height: 100%;
    display: flex;
    flex-direction: row;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    min-width: 0;
    font-size: 0;
  }
</style>



// WEBPACK FOOTER //
// UI/Container/index.vue